// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-marker[data-v-30403a54]{border:none;box-shadow:0 4px 25px 0 rgba(0,0,0,.25)}.frisbuy-popup-image .frisbuy-image-area .frisbuy-image-area__image-as-background[data-v-30403a54]{background-position:top}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
